import React from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import UserMessageIdData from "./user-message-id-data";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3PageDiv from "../../../core/et3-page-div";
import UserMessagesIdForm from "./user-message-id-form";

const UserMessagesId = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName("USER_MESSAGE_ID", "USER_MESSAGE_ID");
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("USER")}
        subTitle={i18n.get("MONITOR_USER_MESSAGE_ID")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <UserMessagesIdForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <UserMessageIdData />
    </ET3PageDiv>
  );
});
export default UserMessagesId;
